export const PRODUCT_CONDITIONS = [
  { value: "NEW", label: "New" },
  { value: "USED_LIKE_NEW", label: "Used - Like New" },
  { value: "USED_GOOD", label: "Used - Good" },
  { value: "USED_FAIR", label: "Used - Fair" },
  { value: "REFURBISHED", label: "Refurbished" },
];
